__turbopack_context__.v({
  "buttonRows": "pXdFFa_buttonRows",
  "buttonTabs": "pXdFFa_buttonTabs",
  "dot": "pXdFFa_dot",
  "dotsContainer": "pXdFFa_dotsContainer",
  "name": "pXdFFa_name",
  "profile": "pXdFFa_profile",
  "quote": "pXdFFa_quote",
  "reviewItem": "pXdFFa_reviewItem",
  "reviewsContainer": "pXdFFa_reviewsContainer",
  "scrollContainer": "pXdFFa_scrollContainer",
});
